module.exports = __webpack_public_path__ + "img/female_avatar.dbb1e811.png";